import { Input } from '@angular/core';
import { BuilderField } from '../../models/builder.model';

export class FBAbstractControl {
  @Input() control: BuilderField;

  constructor() {}

  static DefaultProperties() {
    return Object.freeze({
      referenceName: { type: 'string', source: 'control.name' },
      title: { type: 'string', source: 'control.title' },
      fieldType: { type: 'string', source: 'model.fieldType' },
      eventJs: { type: 'text', source: 'model.eventJs' },
      class: { type: 'string', source: 'model.css' },
      id: { type: 'string', source: 'model.id' },
      rowSpan: { type: 'string', source: 'control.rowSpan' },
      dbTypeName: { type: 'string', source: 'model.dbTypeName' },
      description: { type: 'string', source: 'model.description' },
      placeholder: { type: 'string', source: 'model.placeholder' },
      tooltip: { type: 'text', source: 'model.tooltip' },
      uiMask: { type: 'string', source: 'model.uiMask' },
      format: { type: 'string', source: 'model.format' },
      bindings: { type: 'list', source: 'model.bindings' },
      extract: { type: 'object', source: 'model.bindings' },
      min: { type: 'int', source: 'model.maxLength' },
      max: { type: 'int', source: 'model.minLength' },
    });
  }

  static BooleansProperties() {
    return Object.freeze({
      hidden: { type: 'boolean', source: 'control.properties.isHidden' },
      disabled: { type: 'boolean', source: 'control.properties.disabled' },
      required: { type: 'boolean', source: 'control.properties.required' },
      readonly: { type: 'boolean', source: 'model.readonly' },
      isRequiredForGrid: { type: 'boolean', source: 'model.isRequiredForGrid' },
      isRequiredForForm: { type: 'boolean', source: 'model.isRequiredForForm' },
      isValidForGrid: { type: 'boolean', source: 'model.isValidForGrid' },
      isValidForForm: { type: 'boolean', source: 'model.isValidForForm' },
      allowCreate: { type: 'boolean', source: 'model.allowCreate' },
      isValidForReport: { type: 'boolean', source: 'model.isValidForReport' },
      isExtractable: { type: 'boolean', source: 'model.isExtractable' },
      isSingleLookup: { type: 'boolean', source: 'model.isSingleLookup' },
      isDynamicDropDown: { type: 'boolean', source: 'model.isDynamicDropDown' },
      isNonValueType: { type: 'boolean', source: 'model.isNonValueType' },
      hasRelation: { type: 'boolean', source: 'model.hasRelation' },
    });
  }
}
